export default __webpack_public_path__ + "static/media/servicosp4.fb3728e7.jpg";